import React from 'react';
import { Outlet } from 'react-router-dom';
import { Flex } from '@chakra-ui/react';
import Sidebar from '../../components/aside/Sidebar.jsx';
import Navbar from '../../components/nav/Navbar.jsx';
import { useColorModeValue } from '../../components/ui/color-mode';

const MainLayout = () => {
    return (
        <Flex bg={useColorModeValue('gray.300', 'gray.900')} h={'100vh'} w={'100vw'}>
            <Sidebar />
            <Navbar />
            <Outlet /> {/* This renders the child route */}
        </Flex>
    );
};

export default MainLayout;